
  export default {
    async mounted() {
      const lat = parseFloat(this.el.dataset.lat);
      const lng = parseFloat(this.el.dataset.lng);
      const buildingName = this.el.dataset.buildingName;
      const t = (key) => window.I18n[key];
      const noCoordinates = t("No location coordinates available");
      const failedToLoadMap = t("Failed to load map");
      const transitLabel = t("🚇 Transit");

      if (!lat || !lng) {
        this.el.innerHTML = `<div class="flex items-center justify-center h-full text-gray-400">${noCoordinates}</div>`;
        return;
      }

      try {
        await window.Enaia.loadGoogleMaps();

        const map = new google.maps.Map(this.el, {
          zoom: 16,
          minZoom: 3,
          backgroundColor: "#e8eef1",
          center: { lat, lng },
          mapTypeControl: true,
          mapTypeControlOptions: {
            position: google.maps.ControlPosition.TOP_RIGHT,
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          },
          streetViewControl: true,
          streetViewControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
          },
          fullscreenControl: true,
          fullscreenControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
          },
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_CENTER,
          },
          styles: window.Enaia?.GoogleMapsStyles?.DESATURATED_MAP_STYLES || [],
        });

        // SVG circle marker matching dashboard style
        const markerColor = this.el.dataset.markerColor || "#22c55e";
        const radius = 14;
        const strokeWidth = 2.5;
        const size = Math.ceil((radius + strokeWidth) * 2);
        const center = size / 2;
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
          <defs><filter id="ds" x="-20%" y="-20%" width="140%" height="140%"><feDropShadow dx="0" dy="1" stdDeviation="1.5" flood-color="#000" flood-opacity="0.25"/></filter></defs>
          <circle cx="${center}" cy="${center}" r="${radius}" fill="${markerColor}" fill-opacity="0.95" stroke="#fff" stroke-width="${strokeWidth}" filter="url(#ds)"/>
        </svg>`;
        new google.maps.Marker({
          position: { lat, lng },
          map,
          title: buildingName,
          icon: {
            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
            scaledSize: new google.maps.Size(size, size),
            anchor: new google.maps.Point(center, center),
          },
        });

        // Transit layer with toggle button
        const transitLayer = new google.maps.TransitLayer();
        let transitEnabled = false;

        const transitBtn = document.createElement("button");
        transitBtn.innerHTML = transitLabel;
        transitBtn.className = "transit-toggle-btn";
        transitBtn.style.cssText = `
          background: white;
          border: none;
          border-radius: 2px;
          box-shadow: rgba(0,0,0,0.3) 0 1px 4px -1px;
          margin: 10px;
          padding: 8px 12px;
          font-size: 14px;
          cursor: pointer;
          font-family: Roboto, Arial, sans-serif;
        `;

        transitBtn.addEventListener("click", () => {
          transitEnabled = !transitEnabled;
          transitLayer.setMap(transitEnabled ? map : null);
          transitBtn.style.background = transitEnabled ? "#e8f5e9" : "white";
          transitBtn.style.fontWeight = transitEnabled ? "bold" : "normal";
        });

        map.controls[google.maps.ControlPosition.TOP_LEFT].push(transitBtn);
      } catch (error) {
        console.error("Error loading Google Maps:", error);
        this.el.innerHTML = `<div class="flex items-center justify-center h-full text-red-500">${failedToLoadMap}</div>`;
      }
    },

    destroyed() {
      // Cleanup if needed
    }
  }
